module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New Member Request | New Member Requests","approve":"Approve","deny":"Deny","btnClose":"Close Requests"},"es":{"title":"Nueva Solicitud de Miembro | Nuevas Solicitudes de Miembros","approve":"Aprobar","deny":"Denegar","btnClose":"Cerrar Solicitudes"}}')
  delete Component.options._Ctor
}
